import React from "react";
import { Box, Typography,IconButton, useMediaQuery } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useLanguage } from "../context/LanguageContext.js";

const PageCGU = ({ onClose }) => {
  const { t } = useLanguage();
  const isMobile = useMediaQuery("(max-width:600px)");

  const handleClose = () => {
  if (onClose) {
    onClose(); // si tu passes une fonction de fermeture en prop
  } else {
    if (window.history.length > 1) {
      window.history.back(); // retour si historique dispo
    } else {
      window.close(); // ferme l’onglet si possible
    }
  }
};


  return (
    <Box sx={{ 
      padding: 4, 
      backgroundColor: "#f4ece2", 
      minHeight: "100vh",
      position: "relative"
      }}
      >
        {isMobile && (
        <IconButton
          onClick={handleClose}
          sx={{
            position: "absolute",
            top: 8,
            right: 8,
            color: "#333"
          }}
        >
          <CloseIcon />
        </IconButton>
      )}

      <Typography variant="h4" gutterBottom>
        {t("RGPDGeneralTerms")}
      </Typography>

      <Typography variant="body1" paragraph>
        {t("RGPDAcceptUseConditions")}
      </Typography>

      <Typography variant="h6" gutterBottom>
        {t("RGPD1PersonalDataProtection")}
      </Typography>
      <Typography variant="body2" paragraph>
        {t("RGPDDataProtectionRegulationRules")}
      </Typography>

      <Typography variant="h6" gutterBottom>
        {t("RGPDPurposeCollection")}
      </Typography>
      <Typography variant="body2" paragraph>
        {t("RGPDDataUtilization")}
      </Typography>

      <Typography variant="h6" gutterBottom>
        {t("RGPDUsersRights")}
      </Typography>
      <Typography variant="body2" paragraph>
        {t("RGPDUsersContacts")}
      </Typography>

      <Typography variant="h6" gutterBottom>
        {t("RGPDResponsibility")}
      </Typography>
      <Typography variant="body2" paragraph>
        {t("RGPDUsersResponsibility")}
      </Typography>

      <Typography variant="h6" gutterBottom>
        {t("RGPD5Modifications")}
      </Typography>
      <Typography variant="body2" paragraph>
        {t("RGPDModificationschecks")}
      </Typography>
    </Box>
  );
};

export default PageCGU;
